<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered.has-text-dark
            //- h1.title Vista del documento
            a.button.is-black.is-rounded(@click="backPage")
              i.fas.fa-arrow-left

        .card
          .card-content

            .card-header
              .card-header-title
                h5.subtitle {{ this.documents.name }}
              .circulitos
              span.circulito Copia controlada - {{documents.version}}
              .button.is-black.is-rounded.is-size-6.mt-4(:to="''" @click="downloadFile(documents.file_name)" title="Descargar una copia controlada con numeración")
                i.fas.fa-download.fa-stack-1x.fa-inverse
              //- .button.is-danger.is-rounded.is-size-6.mt-4.ml-2(:to="''" @click="downloadFile(documents.file_name)" title="Descargar una copia controlada con numeración")
              //-   i.fas.fa-trash.fa-stack-1x.fa-inverse

            .card-body(v-if="documents && documents.mime_type === 'application/pdf'")
              .archivo
                .iframe-container
                  iframe(v-if="documents && documents.mime_type === 'application/pdf'" :src="`${documents.temp_url}`" width="100%" height="600px" frameborder="0")
                  .overlay(v-if="documents && documents.mime_type === 'application/pdf'")
            .columns
              .column.is-full.has-text-centered
                p.has-text-danger.is-size-3.mt-5(v-if="documents && documents.mime_type != 'application/pdf'")
                  | Este formato de archivo no tiene una vista previa
                .a.button.is-black.is-rounded.is-size-5.mt-4.ml-2.mb-3(@click="closeModal")
                  i.fas.fa-bullhorn.mr-2.flip-vertical
                  p Reportar un error o sugerencia en el archivo
                  i.fas.fa-bullhorn.ml-2

          .modal.is-active(v-if="isChangeActive")
            .modal-background.custom-background
              .modal-card
                header.modal-card-head
                  p.modal-card-title SOLICITAR UN CAMBIO EN UN DOCUMENTO
                  button.modal-close.is-large(@click="closeModal")
                  button.button(@click="closeModal")
                    i.fas.fa-times
                section.modal-card-body.has-text-centered.strong
                  .form.box
                    .field.mt-3(v-if="isChangeActive")
                      h2
                        strong TIPO DE DOCUMENTO
                        .field.mt-3(v-if="isChangeActive")
                    .radios.mt-1
                      label.radio
                        | MANUAL
                        input.radio.ml-3(type="radio" name="documentType" value="1" v-model="changeRequest.document_type")
                      label.radio
                        | INSTRUCTIVO
                        input.radio.ml-3(type="radio" name="documentType" value="2" v-model="changeRequest.document_type")
                      label.radio
                        | PLAN
                        input.radio.ml-3(type="radio" name="documentType" value="3" v-model="changeRequest.document_type")
                      label.radio
                        | PROCEDIMIENTO
                        input.radio.ml-3(type="radio" name="documentType" value="4" v-model="changeRequest.document_type")
                      label.radio
                        | PROGRAMA
                        input.radio.ml-3(type="radio" name="documentType" value="5" v-model="changeRequest.document_type")
                      label.radio
                        | FORMATO
                        input.radio.ml-3(type="radio" name="documentType" value="6" v-model="changeRequest.document_type")
                    hr
                    h2
                      strong ORIGEN DEL CAMBIO
                    .radios.mt-1
                      label.radio
                        | SUGERENCIA
                        input.radio.ml-3(type="radio" name="changeOrigin" value="1" v-model="changeRequest.origin_of_change")
                      label.radio
                        | RECOMENDACION ICR
                        input.radio.ml-3(type="radio" name="changeOrigin" value="2" v-model="changeRequest.origin_of_change")
                      label.radio
                        | CAMBIO DE TECNOLOGÍA
                        input.radio.ml-3(type="radio" name="changeOrigin" value="3" v-model="changeRequest.origin_of_change")
                      label.radio
                        | HALLAZGO DE AUDITORIA
                        input.radio.ml-3(type="radio" name="changeOrigin" value="4" v-model="changeRequest.origin_of_change")
                      label.radio
                        | ACCIÓN DE MEJORA
                        input.radio.ml-3(type="radio" name="changeOrigin" value="5" v-model="changeRequest.origin_of_change")
                      label.radio
                        | CAMBIO EN EL PROCESO
                        input.radio.ml-3(type="radio" name="changeOrigin" value="6" v-model="changeRequest.origin_of_change")

                      hr
                      h2
                        strong MOTIVO DEL CAMBIO
                      .control.mt-1
                        textarea.textarea(
                                          rows="2"
                                          placeholder="Indique la razón por la que desea realizar un cambio en el documento"
                                          v-model="changeRequest.reason_for_change")
                      hr
                      h2
                        strong ESTADO ACTUAL
                      .control.mt-1
                        textarea.textarea(
                                          rows="1"
                                          placeholder="Describa la situación en la que se encuentra actualmente el archivo"
                                          v-model="changeRequest.current_status")
                      hr
                      h2
                        strong CAMBIO PROPUESTO
                      .control.mt-1
                        textarea.textarea(rows="1"
                                          placeholder="Describa el cambio que desea realizar al documento"
                                          v-model="changeRequest.proposed_change")

                footer.modal-card-foot.has-text-right
                  .buttons
                    button.button.is-dark(@click="closeModal") Cancelar
                    button.button.is-black(@click="sendResponse") Enviar solicitud


        input#fileInput(type="file" style="display: none" @change="handleFileChange")
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarCORP from '@/components/layout/NavBarCorpo.vue'
import sasisopaAPI from "@/services/axios_sasisopa.js";
import { mapState } from 'vuex';

export default {
  name: 'FilesSASISOPA',
  components: { Loader, NavBarCORP  },
  data () {
    return {
      isLoading: false,
      documents: [],
      comments: '',
      responses: [],
      newResponse: '',
      currentDocumentUrl: null,
      isChangeActive: false,
      changeRequest:{
        document_type: null,
        origin_of_change: null,
        reason_for_change:"",
        current_status:"",
        proposed_change:"",
      },

    }
  },
  methods: {
    async fetchData() {
    try {
      this.isLoading = true;
      const response = await sasisopaAPI.getFile(this.$route.params.id);
      console.log(response);

      const base64PDF = response.data.content;

      const byteCharacters = atob(base64PDF);
      const byteNumbers = new Uint8Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const blob = new Blob([byteNumbers], { type: 'application/pdf' });
      const temp_url = URL.createObjectURL(blob);

      this.documents = {
        ...response.data,
        temp_url,
      };

      window.addEventListener('unload', () => {
        URL.revokeObjectURL(temp_url);
      });

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      this.isLoading = false;
    }
  },

    addFile() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.type === 'application/pdf') {
          this.errorMessage = '';
        } else {
          this.errorMessage = 'No hay vista previa disponible para este tipo de archivo.';
        }
      }
    },

    backPage() {
      this.$router.back();
    },

    closeModal() {
      this.isChangeActive = !this.isChangeActive;
      // this.$router.push(`/SASISOPA/solicitud-cambio/${this.$route.params.id}`);
    },

        // current_status:"",
        // proposed_change:"",
    sendResponse() {
      this.isLoading = true;
        if (this.changeRequest.document_type && this.changeRequest.origin_of_change && this.changeRequest.reason_for_change != "") {
          this.guardarForm()
        } else {
          // if (!this.document.name) {
          //   this.datosFaltantes.push('El nombre es requerido.')
          // }
          // if (!this.document.consecutive) {
          //   this.datosFaltantes.push('El numero consecutivo es requerido.')
          // }
          // if (!this.document.code) {
          //   this.datosFaltantes.push('El codigo es requerido.')
          // }
          this.isLoading = false;
          alert("llene correctamente el formulario")
        }
    },

    async guardarForm() {
        try {
          const data = {
            media_id: this.documents. id,
            document_code: this.documents.file_name,
            document_name: this.documents.file_name.split(' ')[0],
            document_type: this.changeRequest.document_type,
            origin_of_change: this.changeRequest.origin_of_change,
            reason_for_change: this.changeRequest.reason_for_change,
            proposed_change: this.changeRequest.proposed_change,
            current_status: this.changeRequest.current_status,
          };
          const response = await sasisopaAPI.postChangeRequest(data);
          this.$router.push(`/SASISOPA/mis-solicitudes-cambio`);
          return response;
        } catch (error) {
          console.log(error);
          throw error;
        }
      },

      async downloadVoucher(id) {
        this.isLoading = true;
        const response = await sasisopaAPI.getRequestVoucher(id);
        this.isLoading = false;
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'voucher_solicitud_cambio_'+this.documents.file_name+'.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        this.closeModal();
      },

      async downloadFile(fileName) {
  this.isLoading = true;
  try {
    const response = await sasisopaAPI.DownloadFile(this.$route.params.id);
    console.log(response.data.data);
    if (response.data.data.mime_type === "application/pdf") {
      this.fetchData();
    } else {
      const byteCharacters = atob(response.data.content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: response.data.mime_type });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "COPIA_CONTROLADA_" + response.data.version + "_" + response.data.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.fetchData();
    }
  } catch (error) {
    this.isLoading = false;
    console.error('Error downloading file:', error);
    this.fetchData();
  }
},
  obtenerUser() {
  }
  },
  created () {
    this.$store.commit('irEstaciones', 'CORP');
    this.obtenerUser();
    this.fetchData();
  }
}
</script>

<style lang="css" scoped>
.card {
  border-radius: 8px;
  box-shadow: 0 4px 8px #c7c7c71f;
}

.circulitos {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.circulito {
  display: flex;
  background-color: #ffffff;
  color: #057D8D;
  border-color: #8d0505;
  border: solid;
  border-radius: 50%;
  padding: 0.5rem;
  text-align: center;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  margin: 1rem;
}
.selected{
background-color: #057D8D;
  color: #fff;
   cursor: pointer;
}

.card-header {
  margin-bottom: 1rem;
}

.card-body {
  margin-bottom: 1rem;
}

.archivo iframe {
  width: 100%;
  height: 600px;
}

.input {
  margin-top: 1rem;
}

.input textarea {
  width: 100%;
  height: 100px;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.respuestas {
  margin-top: 1rem;
}

.respuestas div {
  margin-bottom: 0.5rem;
}

.respuestas input {
  width: calc(100% - 90px);
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.respuestas button {
  width: 80px;
  margin-left: 10px;
}
.iframe-container {
  position: relative;
  width: 100%;
  height: 600px; /* O el tamaño que necesites */
}

.iframe-container iframe {
  width: 100%;
  height: 100%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 24.3%;
  height: 14.5%;
  background: rgba(30, 35, 63, 0);
  pointer-events: auto;
  z-index: 10;
  cursor: no-drop;
  margin-left: 75%;
}

.flip-vertical {
            transform: scaleX(-1);
            display: inline-block; /* Asegúrate de que el ícono tenga un bloque en línea */
        }
.custom-background {
  background-color: #0c0c0cc0;
}
</style>



// WEBPACK FOOTER //
// src/components/sasisopa/FileSASISOPA.vue